module.exports = __webpack_public_path__ + "static/media/hard-hat.4b166108.svg";